import { Badge } from "@/components/ui/badge";
import { Card, CardContent } from "@/components/ui/card";
import { useNavigate } from "react-router-dom";

interface PublicCourseCardProps {
  course: {
    id: string;
    title: string;
    slug: string;
    description: string | null;
    thumbnail_url: string | null;
    category: string | null;
    landing_page_price: string | null;
    landing_page_badge: string | null;
  };
}

export const PublicCourseCard = ({ course }: PublicCourseCardProps) => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(`/kurs/${course.slug}`);
  };

  return (
    <Card 
      className="group cursor-pointer overflow-hidden border-border/50 bg-card hover:shadow-xl transition-all duration-300 hover:scale-[1.02] hover:border-primary/30"
      onClick={handleClick}
    >
      {/* Thumbnail */}
      <div className="relative aspect-video overflow-hidden bg-muted">
        {course.thumbnail_url ? (
          <img
            src={course.thumbnail_url}
            alt={course.title}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center bg-gradient-to-br from-primary/10 to-accent/10">
            <span className="text-4xl">🎵</span>
          </div>
        )}
        
        {/* Category Badge */}
        {course.category && (
          <Badge 
            variant="secondary" 
            className="absolute top-3 left-3 bg-background/90 backdrop-blur-sm text-xs"
          >
            {course.category}
          </Badge>
        )}
        
        {/* Price Badge */}
        <div className="absolute bottom-3 right-3">
          <Badge 
            className="bg-primary text-primary-foreground font-semibold shadow-lg"
          >
            {course.landing_page_price || "Details ansehen"}
          </Badge>
        </div>
      </div>

      <CardContent className="p-4">
        {/* Title */}
        <h3 className="font-semibold text-foreground line-clamp-2 mb-2 group-hover:text-primary transition-colors">
          {course.title}
        </h3>
        
        {/* Description */}
        {course.description && (
          <p className="text-sm text-muted-foreground line-clamp-2">
            {course.description.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ').trim()}
          </p>
        )}
        
        {/* CTA Text */}
        <div className="mt-3 pt-3 border-t border-border/50">
          <span className="text-sm font-medium text-primary group-hover:underline">
            Mehr erfahren →
          </span>
        </div>
      </CardContent>
    </Card>
  );
};
